import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackCall = (source) => {
  axios.post(`${API}/call-clicks`, { source }).catch(() => {});
};
